import { render, staticRenderFns } from "./SiteNav.vue?vue&type=template&id=2b9aa3c4&"
import script from "./SiteNav.vue?vue&type=script&lang=js&"
export * from "./SiteNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports